import { memberPathKey, type MemberIndex } from 'src/components/star-grid/utils/subset-editor/memberSubset';

/** Root→member label chain for one tree POSITION (not a member id — a multi-parent member has one
 * chain per parent, and the position is what says which one is checked). Each ancestor is resolved
 * through the index so the chain reads in display labels, not raw element ids. */
export const memberChainLabels = (index: MemberIndex, key: string): string[] => {
  const entry = index.get(key);
  if (!entry) return [];
  return entry.path.map((id, depth) => index.get(memberPathKey(entry.path.slice(0, depth + 1)))?.label ?? id);
};

/** The chain to show for a selection: the shallowest checked position, so a parent-level tick reads
 * as its own chain rather than the first of its cascaded descendants. */
export const selectionChainLabels = (index: MemberIndex, checked: readonly string[]): string[] => {
  const shallowest = checked.reduce<string | undefined>((best, key) => {
    const depth = index.get(key)?.depth ?? Infinity;
    const bestDepth = best ? index.get(best)?.depth ?? Infinity : Infinity;
    return depth < bestDepth ? key : best;
  }, undefined);
  return shallowest ? memberChainLabels(index, shallowest) : [];
};
